import { BiometricValidationProvider } from "./biometric-validation";

export function Providers({ children }) {
  return <BiometricValidationProvider>{children}</BiometricValidationProvider>;
}
